import { render, staticRenderFns } from "./AlgorithmView.vue?vue&type=template&id=f2ea3934&scoped=true&"
import script from "./AlgorithmView.vue?vue&type=script&lang=js&"
export * from "./AlgorithmView.vue?vue&type=script&lang=js&"
import style0 from "./AlgorithmView.vue?vue&type=style&index=0&id=f2ea3934&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ea3934",
  null
  
)

export default component.exports